import { ComboHeader } from "components/blocks/ComboHeader";
import { routes } from "routes";
import { Tabs, TabName, UserList } from "./components";
import { useFollowingFeed } from "queries";
import { FooterAds } from "components/ads/FooterAds";
import { Fragment } from "react";

interface IProps {
  userName: string;
}

export const FollowingPage = (props: IProps) => {
  document.title = "Account You Follow | RedGIFs";

  return (
    <Fragment>
      <div className="followersPage wide page">
        <ComboHeader back={routes.user(props.userName)} text="Following" />
        <Tabs tab={TabName.Following} />
        <UserList userName={props.userName} query={useFollowingFeed} />
      </div>
      <FooterAds/>
    </Fragment>
  );
};
